
import { defineComponent,ref } from 'vue';
import PsModal from '@/components/core/modals/PsModal.vue';
import PsLabel from '@/components/core/label/PsLabel.vue';
import PsLabelTitle3 from '@/components/core/label/PsLabelTitle3.vue';
import PsLabelHeader6 from '@/components/core/label/PsLabelHeader6.vue';
import PsButton from '@/components/core/buttons/PsButton.vue';
import PsLoadingDialog from '@/components/core/dialog/PsLoadingDialog.vue';
import { createOfflinePaymentProviderState } from '@/store/modules/offlinePayment/OfflinePaymentProvider';

export default defineComponent({
    name : 'OfflinePaymentModal',
    components : {
        PsModal,
        PsLabel,
        PsButton,
        PsLabelTitle3,
        PsLoadingDialog,
        PsLabelHeader6
    },
    setup() {
        
        
        const psmodal = ref();    
        const psloading = ref();  
        const offlineProvider = createOfflinePaymentProviderState();
        
        let okClicked: Function;
        let cancelClicked: Function;
        
        async function openModal(okClickedAction: Function, cancelClickedAction: Function) { 
            await offlineProvider.loadOfflinePaymentMethodList();
            okClicked = okClickedAction;
            cancelClicked= cancelClickedAction; 

            psmodal.value.toggle(true);
            
        }

        function actionClicked(status) {
            if(status == 'yes') {
                okClicked();
            }else {
                cancelClicked();
            }
            psmodal.value.toggle(false);
        }

        return {
            psmodal,
            psloading,
            openModal,
            actionClicked,
            offlineProvider,
        }
    },
})
